export default "__VITE_ASSET__BK1rLRmD__"